(function(){
  const DEFAULT_DISCOUNT = 0.15;
  const BOOST_DISCOUNT = 0.20;
  const THRESHOLD = 149900;   // ₹1,499 in paise

  // Collections eligible for the 20% offer price
  const BOOST_COLLECTIONS = ['god-idols', 'puja-accessories'];

  function getDiscount(slot){
    const handles = (slot.getAttribute('data-collections') || '')
      .split(',')
      .map(h => h.trim())
      .filter(Boolean);

    const isBoosted = handles.some(h => BOOST_COLLECTIONS.includes(h));
    return isBoosted ? BOOST_DISCOUNT : DEFAULT_DISCOUNT;
  }

  function formatMoney(paise){
    const rupees = (paise/100).toFixed(2);
    return `₹${rupees.replace(/\.00$/, '')}`;
  }

  function computeOffer(paise, discount){
    return Math.round(paise * (1 - discount));
  }

  function mountOfferBox(){
    const slot = document.querySelector('#aop-offer-slot[data-aop-pdp]');
    if(!slot) return;

    const priceSection = document.querySelector('[data-product-price]') ||
                         document.querySelector('.m-price') ||
                         document.querySelector('.product__price');
    if(!priceSection) return;

    if(!slot._rendered){
      const salePaise = Number(slot.getAttribute('data-price')) || 0;
      const discount = getDiscount(slot);
      const offerPaise = computeOffer(salePaise, discount);
      const offerPrice = formatMoney(offerPaise);
      const discountLabel = Math.round(discount * 100);
      const code = discount === BOOST_DISCOUNT ? 'SHRAVAN20' : 'PUJA15';

      slot.innerHTML = `
        <div class="aop-offer-box">
          <div class="aop-offer-left">
            <div class="aop-offer-title">
              <span class="aop-offer-icon">🏷️</span>
              <span class="aop-offer-head">Offer Price :</span> 
              <span class="aop-offer-price aop-price">${offerPrice}</span>
            </div>
            <div class="aop-offer-sub">
              Use code <span class="aop-offer-code">${code}</span> on orders ₹1499+
            </div>
          </div>
          <div class="aop-offer-pill">EXTRA ${discountLabel}% OFF</div>
        </div>
      `;

      priceSection.parentNode.insertBefore(slot, priceSection.nextSibling);
      slot._rendered = true;
    }
  }

  function updateOfferPrice(){
    const slot = document.querySelector('#aop-offer-slot[data-aop-pdp]');
    if(!slot) return;

    const priceNode = document.querySelector('[data-product-price]');
    const vPrice = Number(slot.getAttribute('data-price'));
    const salePaise = vPrice || (priceNode ? Number(priceNode.getAttribute('data-price')) : 0);
    if(!salePaise) return;

    const discount = getDiscount(slot);
    const offer = computeOffer(salePaise, discount);
    const priceEl = slot.querySelector('.aop-price');
    if(priceEl) priceEl.textContent = formatMoney(offer);

    const pillEl = slot.querySelector('.aop-offer-pill');
    if(pillEl) pillEl.textContent = `EXTRA ${Math.round(discount*100)}% OFF`;

    const codeEl = slot.querySelector('.aop-offer-code');
    if(codeEl) codeEl.textContent = discount === BOOST_DISCOUNT ? 'SHRAVAN20' : 'PUJA15';
  }

  ['variant:change','product:variant-change','theme:variant:change'].forEach(ev=>{
    document.addEventListener(ev, function(e){
      if(e.detail && e.detail.variant){
        const slot = document.querySelector('#aop-offer-slot[data-aop-pdp]');
        if(slot) slot.setAttribute('data-price', e.detail.variant.price);
      }
      updateOfferPrice();
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    mountOfferBox();
    updateOfferPrice();
  });
})();